import React, { useState } from "react";
import DashboardSide from "../dashboard/DashboardSide";
import WalletCenter from "./WalletCenter";
import MobileMenu from "../dashboard/MobileMenu";

export default function Wallet() {
  const [modal, setModal] = useState(false);
  return (
    <div className="h-full bg-[#f6f6f6] flex items-center justify-center">
      <DashboardSide />
      {modal && <MobileMenu setModal={setModal} />}
      <WalletCenter setModal={setModal} />
    </div>
  );
}